export default __webpack_public_path__ + "static/media/LogoSupport.2a1ec3fc.svg";